// extracted by mini-css-extract-plugin
export var root = "styles-module--root--1Jbn5";
export var contentHolder = "styles-module--content-holder--2AKVG";
export var disclaimer = "styles-module--disclaimer--2VrsR";